import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Card from "../../components/Cards/Card";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Slider from "@mui/material/Slider";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";

import LayoutCardsWrapper from "../../components/LayoutCardsWrapper/LayoutCardsWrapper";
import CardWrapper from "../../components/LayoutCardsWrapper/CardWrapper";
import KpiCardSimulador from "../../components/KPI/KpiCardSimulador";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import NativeObject from "../../components/NativeObject/NativeObject";

import Oportunidade from "../../assets/icons/Simulador/oportunidade.svg";
import PdvsTrabalhar from "../../assets/icons/Simulador/pdvs-trabalhar.svg";
import PdvsConquistar from "../../assets/icons/Simulador/pdvs-conquistar.svg";
import PdvsAlavancar from "../../assets/icons/Simulador/pdvs-alavancar.svg";
import TooltipInfo from "../../components/TooltipInfo/TooltipInfo";
import { useTour } from "@reactour/tour";

function SimuladorDesktop({ app, config }) {
  const { container } = config.simulador;
  const [expanded, setExpanded] = React.useState(false);
  const { currentStep } = useTour();

  const labelTooltips = [
    "Número de PDVs que o cliente tem de oportunidade",
    "Valor médio que o PDVs compra do cliente",
    "PDVS que não compraram do cliente no período do estudo",
    "Volume de PDVs com oportunidade de possível relação comercial",
    "Totalização em reais das possíveis oportunidades a serem conquistadas",
  ];

  const [vSimulPercReaisHHB, setVSimulPercReaisHHB] = useState(0);
  const [vSimulPercReaisHB, setVSimulPercReaisHB] = useState(0);
  const [vSimulPercReaisMB, setVSimulPercReaisMB] = useState(0);
  const [vSimulPercReaisLB, setVSimulPercReaisLB] = useState(0);

  const [vSimulPercPdvHBtoHHB, setVSimulPercPdvHBtoHHB] = useState(0);
  const [vSimulPercPdvMBtoHHB, setVSimulPercPdvMBtoHHB] = useState(0);
  const [vSimulPercPdvLBtoHHB, setVSimulPercPdvLBtoHHB] = useState(0);
  const [vSimulPercPdvVLBtoHHB, setVSimulPercPdvVLBtoHHB] = useState(0);
  const [vSimulPercPdvSCtoHHB, setVSimulPercPdvSCtoHHB] = useState(0);

  const [vSimulPercPdvMBtoHB, setVSimulPercPdvMBtoHB] = useState(0);
  const [vSimulPercPdvLBtoHB, setVSimulPercPdvLBtoHB] = useState(0);
  const [vSimulPercPdvVLBtoHB, setVSimulPercPdvVLBtoHB] = useState(0);
  const [vSimulPercPdvSCtoHB, setVSimulPercPdvSCtoHB] = useState(0);

  const [vSimulPercPdvLBtoMB, setVSimulPercPdvLBtoMB] = useState(0);
  const [vSimulPercPdvVLBtoMB, setVSimulPercPdvVLBtoMB] = useState(0);
  const [vSimulPercPdvSCtoMB, setVSimulPercPdvSCtoMB] = useState(0);

  const [vSimulPercPdvVLBtoLB, setVSimulPercPdvVLBtoLB] = useState(0);
  const [vSimulPercPdvSCtoLB, setVSimulPercPdvSCtoLB] = useState(0);

  const marks = [
    {
      value: 0,
      label: "0",
    },

    {
      value: 20,
      label: "20%",
    },
    {
      value: 40,
      label: "40%",
    },
    {
      value: 60,
      label: "60%",
    },
    {
      value: 80,
      label: "80%",
    },
    {
      value: 100,
      label: "100%",
    },
  ];

  const handleSliderChangeCommitted = (event, newValue) => {
    const value = parseFloat(newValue, 10);
    app.variable.setNumValue("vSimulPercReaisHHB", value / 100);
  };
  function updateSlider() {
    app.variable.getContent("vSimulPercReaisHHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercReaisHHB(data * 100);
      }
    });
  }

  const handleSliderChangeCommittedHB = (event, newValue) => {
    const value = parseFloat(newValue, 10);
    app.variable.setNumValue("vSimulPercReaisHB", value / 100);
  };
  function updateSliderHB() {
    app.variable.getContent("vSimulPercReaisHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercReaisHB(data * 100);
      }
    });
  }

  const handleSliderChangeCommittedMB = (event, newValue) => {
    const value = parseFloat(newValue, 10);
    app.variable.setNumValue("vSimulPercReaisMB", value / 100);
  };
  function updateSliderMB() {
    app.variable.getContent("vSimulPercReaisMB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercReaisMB(data * 100);
      }
    });
  }

  const handleSliderChangeCommittedLB = (event, newValue) => {
    const value = parseFloat(newValue, 10);
    app.variable.setNumValue("vSimulPercReaisLB", value / 100);
  };
  function updateSliderLB() {
    app.variable.getContent("vSimulPercReaisLB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercReaisLB(data * 100);
      }
    });
  }
  // HHB
  function handleChangeHB(event) {
    setVSimulPercPdvHBtoHHB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvHBtoHHB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSlider();
    event.preventDefault();
  }
  function handleChangeMB(event) {
    setVSimulPercPdvMBtoHHB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvMBtoHHB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSliderMB();
    event.preventDefault();
  }
  function handleChangeLB(event) {
    setVSimulPercPdvLBtoHHB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvLBtoHHB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSlider();
    event.preventDefault();
  }
  function handleChangeVLB(event) {
    setVSimulPercPdvVLBtoHHB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvVLBtoHHB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSlider();
    event.preventDefault();
  }
  function handleChangeSC(event) {
    setVSimulPercPdvSCtoHHB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvSCtoHHB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSlider();
    event.preventDefault();
  }
  // HB
  function handleChangeHBMB(event) {
    setVSimulPercPdvMBtoHB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvMBtoHB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSliderHB();
    event.preventDefault();
  }
  function handleChangeHBLB(event) {
    setVSimulPercPdvLBtoHB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvLBtoHB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSliderHB();
    event.preventDefault();
  }
  function handleChangeHBVLB(event) {
    setVSimulPercPdvVLBtoHB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvVLBtoHB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSliderHB();
    event.preventDefault();
  }
  function handleChangeHBSC(event) {
    setVSimulPercPdvSCtoHB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvSCtoHB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSliderHB();
    event.preventDefault();
  }

  // MB
  function handleChangeMBLB(event) {
    setVSimulPercPdvLBtoMB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvLBtoMB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSliderMB();
    event.preventDefault();
  }
  function handleChangeMBVLB(event) {
    setVSimulPercPdvVLBtoMB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvVLBtoMB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSliderMB();
    event.preventDefault();
  }
  function handleChangeMBSC(event) {
    setVSimulPercPdvSCtoMB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvSCtoMB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSliderMB();
    event.preventDefault();
  }

  // LB
  function handleChangeLBVLB(event) {
    setVSimulPercPdvVLBtoLB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvVLBtoLB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSliderLB();
    event.preventDefault();
  }
  function handleChangeLBSC(event) {
    setVSimulPercPdvSCtoLB(event.target.value);
    if (app) {
      app.variable.setNumValue(
        "vSimulPercPdvSCtoLB",
        parseFloat(event.target.value / 100, 10)
      );
    }
    updateSliderLB();
    event.preventDefault();
  }

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  function valuetext(value) {
    return `${value}%`;
  }

  useEffect(() => {
    updateSlider();
    updateSliderHB();
    updateSliderMB();
    updateSliderLB();

    app.variable.getContent("vSimulPercPdvHBtoHHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvHBtoHHB(data * 100);
      }
    });
    app.variable.getContent("vSimulPercPdvMBtoHHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvMBtoHHB(data * 100);
      }
    });
    app.variable.getContent("vSimulPercPdvLBtoHHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvLBtoHHB(data * 100);
      }
    });
    app.variable.getContent("vSimulPercPdvVLBtoHHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvVLBtoHHB(data * 100);
      }
    });
    app.variable.getContent("vSimulPercPdvSCtoHHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvSCtoHHB(data * 100);
      }
    });

    app.variable.getContent("vSimulPercPdvMBtoHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvMBtoHB(data * 100);
      }
    });
    app.variable.getContent("vSimulPercPdvLBtoHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvLBtoHB(data * 100);
      }
    });
    app.variable.getContent("vSimulPercPdvVLBtoHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvVLBtoHB(data * 100);
      }
    });
    app.variable.getContent("vSimulPercPdvSCtoHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvSCtoHB(data * 100);
      }
    });

    app.variable.getContent("vSimulPercPdvLBtoHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvLBtoHB(data * 100);
      }
    });
    app.variable.getContent("vSimulPercPdvVLBtoHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvVLBtoHB(data * 100);
      }
    });
    app.variable.getContent("vSimulPercPdvSCtoHB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvSCtoHB(data * 100);
      }
    });

    app.variable.getContent("vSimulPercPdvLBtoMB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvLBtoMB(data * 100);
      }
    });
    app.variable.getContent("vSimulPercPdvVLBtoMB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvVLBtoMB(data * 100);
      }
    });
    app.variable.getContent("vSimulPercPdvSCtoMB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvSCtoMB(data * 100);
      }
    });

    app.variable.getContent("vSimulPercPdvVLBtoLB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvVLBtoLB(data * 100);
      }
    });
    app.variable.getContent("vSimulPercPdvSCtoLB", (reply) => {
      const data = parseFloat(reply.qContent.qString.replace(",", "."), 10);
      if (data !== undefined) {
        setVSimulPercPdvSCtoLB(data * 100);
      }
    });
  }, []);

  return (
    <div className="app simulador">
      <div className="appContent">
        <LayoutCardsWrapper>
          <CardWrapper customClass={"tutorial-sixth-step"} customStyle={{ minHeight: "140px", height: "12vh" }}>
            {container[0].cards.map((card, index) => {
              return (
                <KpiCardSimulador
                  key={index}
                  app={app}
                  KPITitle={{
                    id: card.title.id,
                    hardTitle: card.title.hardTitle,
                  }}
                  iconId={card.nativeObject.iconId}
                  percentageId={card.nativeObject.percentageId}
                  greyValueId={card.nativeObject.greyValueId}
                  valueId={card.nativeObject.valueId}
                  customStyle={{}}
                  isMobile={false}
                  colorIdentfy={card.nativeObject.colorIdentfy}
                  tooltip={card.title.tooltip}
                ></KpiCardSimulador>
              );
            })}
          </CardWrapper>

          <CardWrapper customStyle={{ height: "80%", paddingBottom: "20px" }}>
            <Card
              className={"tutorial-seventh-step"}
              header={{
                hardTitle: container[1].cards[0].title.hardTitle,
                hardSubtitle: container[1].cards[0].subtitle.hard,
                tooltip: container[1].cards[0].title.tooltip,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <Accordion
                expanded={expanded === "panel1" || currentStep === 8 || currentStep === 9}
                onChange={handleChange("panel1")}
                elevation={0}
                sx={{
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  position: "static",
                  marginBottom: "8px",
                }}
              >
                <AccordionSummary
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  sx={{
                    background: "#AE1E1E",
                    color: "#fff",
                    borderRadius: "8px",
                  }}
                >
                  <div
                    style={{
                      height: "38px",
                      width: "100px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <ComboHeader
                      reference={{
                        title: {
                          id: "KPITitle.id",
                          hard: "HHB",
                        },
                      }}
                      classStyle="title-accordion"
                    />
                  </div>
                  <div
                    style={{
                      height: "36px",
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={PdvsConquistar}
                      alt="Conquistar"
                      style={{ width: "32px", height: "32px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"rtznhPK"}
                      reference={{ id: "rtznhPK" }}
                      style={{ marginTop: "8px" }}
                    />
                    <img
                      src={PdvsAlavancar}
                      alt="Alavancar"
                      style={{ width: "32px", height: "32px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"pABJSGU"}
                      reference={{ id: "pABJSGU" }}
                      style={{ marginTop: "8px" }}
                    />
                    <img
                      src={PdvsTrabalhar}
                      alt="Trabalhar"
                      style={{ width: "32px", height: "32px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"jfNpVtC"}
                      reference={{ id: "jfNpVtC" }}
                      style={{ marginTop: "8px" }}
                    />
                    <img
                      src={Oportunidade}
                      alt="Oportunidades"
                      style={{ width: "36px", height: "36px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"dGRnfm"}
                      reference={{ id: "dGRnfm" }}
                      style={{ marginTop: "8px" }}
                    />
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      height: "300px",
                    }}
                  >
                    <div className={"tutorial-eighth-step"} style={{ width: "40%", marginRight: "20PX" }}>
                      {/* TOTAL DE PDVS*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[0]} />} Total de PDVs</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"wNjxcx"}
                            reference={{ id: "wNjxcx" }}
                          />
                        </div>
                      </div>
                      {/* TICKET MEDIO PDVS PARA CLIENTE*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[1]} />} Ticket Médio PDVs para cliente</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"WpYKW"}
                            reference={{ id: "WpYKW" }}
                          />
                        </div>
                      </div>
                      {/* PDVS NOVOS*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[2]} />} PDVs Novos</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"rtznhPK"}
                            reference={{ id: "rtznhPK" }}
                          />
                        </div>
                      </div>
                      {/* PDVS A TRABALHAR*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[3]} />} PDVs a Trabalhar</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"jfNpVtC"}
                            reference={{ id: "jfNpVtC" }}
                          />
                        </div>
                      </div>
                      {/* OPORTUNIDADES EM REAIS*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[4]} />} Oportunidades em reais</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"dGRnfm"}
                            reference={{ id: "dGRnfm" }}
                          />
                        </div>
                      </div>
                      {/* INPUT DO TICKET MEDIO */}
                      <div style={{ marginTop: "20px" }}>
                        <h3>
                          Qual valor/percentual de ticket médio quer atingir?
                        </h3>
                        <div
                          style={{
                            display: "flex",
                            marginTop: "40px",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ width: "65%" }}>
                            <Slider
                              aria-label="Always visible"
                              defaultValue={vSimulPercReaisHHB}
                              getAriaValueText={valuetext}
                              onChangeCommitted={handleSliderChangeCommitted}
                              step={10}
                              marks={marks}
                              valueLabelDisplay="on"
                            />
                          </div>
                          <div style={{ width: "30%" }}>
                            {/* 
                          lINK DE COMO TRANSFORMAR INPUT MASK DO MUI 
                          https://github.com/unicef/material-ui-currency-textfield/blob/master/src/components/CurrencyTextField/CurrencyTextField.js
                          */}
                            <div style={{ width: "100%", height: "100%" }}>
                              <NativeObject
                                className="text-accordion-medio"
                                app={app}
                                key={"XfdtvP"}
                                reference={{ id: "XfdtvP" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={"tutorial-ninth-step"}
                      style={{
                        width: "60%",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "20px",
                        }}
                      >
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#AE521E1A",
                            borderRadius: "4px",
                          }}
                        >
                          <span>HB</span>
                        </div>
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#AE8E1E1A",
                            borderRadius: "4px",
                          }}
                        >
                          <span>MB</span>
                        </div>
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#1E69AE1A",
                            borderRadius: "4px",
                          }}
                        >
                          <span>LB</span>
                        </div>
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#D3EAFF66",
                            borderRadius: "4px",
                          }}
                        >
                          <span>VLB</span>
                        </div>
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#EBEBEB",
                            borderRadius: "4px",
                          }}
                        >
                          <span>SC</span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* HB INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          <OutlinedInput
                            id="outlined-adornment-hb"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvHBtoHHB}
                            onBlur={handleChangeHB}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "33%",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <TooltipInfo text={container[1].cards[0].subcards[0].tooltips[0]} style={{marginRight: "8px"}}/>
                              <NativeObject
                                className="text-accordion"
                                app={app}
                                key={"VpPH"}
                                reference={{ id: "VpPH" }}
                              />
                            </div>
                            <div
                              style={{
                                width: "100%",
                                height: "33%",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <TooltipInfo text={container[1].cards[0].subcards[0].tooltips[1]} style={{marginRight: "8px"}}/>
                              <NativeObject
                                className="text-accordion"
                                app={app}
                                key={"GJukjjU"}
                                reference={{ id: "GJukjjU" }}
                              />
                            </div>

                            <div
                              style={{
                                width: "100%",
                                height: "33%",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <TooltipInfo text={container[1].cards[0].subcards[0].tooltips[2]} style={{marginRight: "8px"}}/>
                              <NativeObject
                                className="text-accordion"
                                app={app}
                                key={"tWgpFS"}
                                reference={{ id: "tWgpFS" }}
                              />
                            </div>
                          </div>
                        </div>
                        {/* MB INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          {" "}
                          <OutlinedInput
                            id="outlined-adornment-mb"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvMBtoHHB}
                            onBlur={handleChangeMB}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"pGzjhRr"}
                              reference={{ id: "pGzjhRr" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"vFLeJ"}
                              reference={{ id: "vFLeJ" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"esWj"}
                              reference={{ id: "esWj" }}
                              style={{ height: "33%" }}
                            />
                          </div>
                        </div>
                        {/* LB INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          {" "}
                          <OutlinedInput
                            id="outlined-adornment-lb"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvLBtoHHB}
                            onBlur={handleChangeLB}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"zEMpva"}
                              reference={{ id: "zEMpva" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"dydjSvc"}
                              reference={{ id: "dydjSvc" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"bKeJTE"}
                              reference={{ id: "bKeJTE" }}
                              style={{ height: "33%" }}
                            />
                          </div>
                        </div>
                        {/* VLB INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          {" "}
                          <OutlinedInput
                            id="outlined-adornment-vlb"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvVLBtoHHB}
                            onBlur={handleChangeVLB}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"aBzvn"}
                              reference={{ id: "aBzvn" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"VZpBPy"}
                              reference={{ id: "VZpBPy" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"PrHNWj"}
                              reference={{ id: "PrHNWj" }}
                              style={{ height: "33%" }}
                            />
                          </div>
                        </div>
                        {/* SC INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          {" "}
                          <OutlinedInput
                            id="outlined-adornment-sc"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvSCtoHHB}
                            onBlur={handleChangeSC}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"meHMp"}
                              reference={{ id: "meHMp" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"HMRgt"}
                              reference={{ id: "HMRgt" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"wXDNPZ"}
                              reference={{ id: "wXDNPZ" }}
                              style={{ height: "33%" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
                elevation={0}
                sx={{
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  position: "static",
                  marginBottom: "8px",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  sx={{
                    background: "#AE521E",
                    color: "#fff",
                    borderRadius: "8px",
                  }}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                >
                  <div
                    style={{
                      height: "38px",
                      width: "100px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <ComboHeader
                      reference={{
                        title: {
                          id: "KPITitle.id",
                          hard: "HB",
                        },
                      }}
                      classStyle="title-accordion"
                    />
                  </div>
                  <div
                    style={{
                      height: "36px",
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={PdvsConquistar}
                      alt="Conquistar"
                      style={{ width: "32px", height: "32px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"ctJVhV"}
                      reference={{ id: "ctJVhV" }}
                      style={{ marginTop: "8px" }}
                    />
                    <img
                      src={PdvsAlavancar}
                      alt="Alavancar"
                      style={{ width: "32px", height: "32px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"WPsCS"}
                      reference={{ id: "WPsCS" }}
                      style={{ marginTop: "8px" }}
                    />
                    <img
                      src={PdvsTrabalhar}
                      alt="Trabalhar"
                      style={{ width: "32px", height: "32px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"ASXKa"}
                      reference={{ id: "ASXKa" }}
                      style={{ marginTop: "8px" }}
                    />
                    <img
                      src={Oportunidade}
                      alt="Oportunidades"
                      style={{ width: "36px", height: "36px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"KESdmF"}
                      reference={{ id: "KESdmF" }}
                      style={{ marginTop: "8px" }}
                    />
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      height: "300px",
                    }}
                  >
                    <div style={{ width: "40%", marginRight: "20PX" }}>
                      {/* TOTAL DE PDVS*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[0]} />} Total de PDVs</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"WGCPZxj"}
                            reference={{ id: "WGCPZxj" }}
                          />
                        </div>
                      </div>
                      {/* TICKET MEDIO PDVS PARA CLIENTE*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[1]} />} Ticket Médio PDVs para cliente</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"RmMutb"}
                            reference={{ id: "RmMutb" }}
                          />
                        </div>
                      </div>
                      {/* PDVS NOVOS*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[2]} />} PDVs Novos</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"ctJVhV"}
                            reference={{ id: "ctJVhV" }}
                          />
                        </div>
                      </div>
                      {/* PDVS A TRABALHAR*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[3]} />} PDVs a Trabalhar</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"ASXKa"}
                            reference={{ id: "ASXKa" }}
                          />
                        </div>
                      </div>
                      {/* OPORTUNIDADES EM REAIS*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[4]} />} Oportunidades em reais</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"KESdmF"}
                            reference={{ id: "KESdmF" }}
                          />
                        </div>
                      </div>
                      {/* INPUT DO TICKET MEDIO */}
                      <div style={{ marginTop: "20px" }}>
                        <h3>
                          Qual valor/percentual de ticket médio quer atingir?
                        </h3>
                        <div
                          style={{
                            display: "flex",
                            marginTop: "40px",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ width: "65%" }}>
                            <Slider
                              aria-label="Always visible"
                              defaultValue={vSimulPercReaisHB}
                              getAriaValueText={valuetext}
                              onChangeCommitted={handleSliderChangeCommittedHB}
                              step={10}
                              marks={marks}
                              valueLabelDisplay="on"
                            />
                          </div>
                          <div style={{ width: "30%" }}>
                            {/* 
                          lINK DE COMO TRANSFORMAR INPUT MASK DO MUI 
                          https://github.com/unicef/material-ui-currency-textfield/blob/master/src/components/CurrencyTextField/CurrencyTextField.js
                          */}
                            <div style={{ width: "100%", height: "100%" }}>
                              <NativeObject
                                className="text-accordion-medio"
                                app={app}
                                key={"jVDXDxC"}
                                reference={{ id: "jVDXDxC" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "60%",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "20px",
                        }}
                      >
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#AE8E1E1A",
                            borderRadius: "4px",
                          }}
                        >
                          <span>MB</span>
                        </div>
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#1E69AE1A",
                            borderRadius: "4px",
                          }}
                        >
                          <span>LB</span>
                        </div>
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#D3EAFF66",
                            borderRadius: "4px",
                          }}
                        >
                          <span>VLB</span>
                        </div>
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#EBEBEB",
                            borderRadius: "4px",
                          }}
                        >
                          <span>SC</span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* MB INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          {" "}
                          <OutlinedInput
                            id="outlined-adornment-mb"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvMBtoHB}
                            onBlur={handleChangeHBMB}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                height: "33%",
                                alignItems: "center",
                              }}
                            >
                              <TooltipInfo
                                text={container[1].cards[0].subcards[1].tooltips[0]}
                                style={{ marginRight: "8px" }}
                              />
                              <NativeObject
                                className="text-accordion"
                                app={app}
                                key={"kJpthHX"}
                                reference={{ id: "kJpthHX" }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                height: "33%",
                                alignItems: "center",
                              }}
                            >
                              <TooltipInfo
                                text={container[1].cards[0].subcards[1].tooltips[1]}
                                style={{ marginRight: "8px" }}
                              />
                              <NativeObject
                                className="text-accordion"
                                app={app}
                                key={"PcSc"}
                                reference={{ id: "PcSc" }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                height: "33%",
                                alignItems: "center",
                              }}
                            >
                              <TooltipInfo
                                text={container[1].cards[0].subcards[1].tooltips[2]}
                                style={{ marginRight: "8px" }}
                              />
                              <NativeObject
                                className="text-accordion"
                                app={app}
                                key={"tpbdYj"}
                                reference={{ id: "tpbdYj" }}
                              />
                            </div>
                          </div>
                        </div>
                        {/* LB INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          {" "}
                          <OutlinedInput
                            id="outlined-adornment-lb"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvLBtoHB}
                            onBlur={handleChangeHBLB}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"jSPsMkj"}
                              reference={{ id: "jSPsMkj" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"NWSvtj"}
                              reference={{ id: "NWSvtj" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"yPzpMJ"}
                              reference={{ id: "yPzpMJ" }}
                              style={{ height: "33%" }}
                            />
                          </div>
                        </div>
                        {/* VLB INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          {" "}
                          <OutlinedInput
                            id="outlined-adornment-vlb"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvVLBtoHB}
                            onBlur={handleChangeHBVLB}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"bDUQbd"}
                              reference={{ id: "bDUQbd" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"taEtJF"}
                              reference={{ id: "taEtJF" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"YHjvQLP"}
                              reference={{ id: "YHjvQLP" }}
                              style={{ height: "33%" }}
                            />
                          </div>
                        </div>
                        {/* SC INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          {" "}
                          <OutlinedInput
                            id="outlined-adornment-sc"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvSCtoHB}
                            onBlur={handleChangeHBSC}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"jBavhU"}
                              reference={{ id: "jBavhU" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"UPXvFT"}
                              reference={{ id: "UPXvFT" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"RWjMPu"}
                              reference={{ id: "RWjMPu" }}
                              style={{ height: "33%" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel3"}
                onChange={handleChange("panel3")}
                elevation={0}
                sx={{
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  position: "static",
                  marginBottom: "8px",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  sx={{
                    background: "#AE8E1E",
                    color: "#fff",
                    borderRadius: "8px",
                  }}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                >
                  <div
                    style={{
                      height: "38px",
                      width: "100px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <ComboHeader
                      reference={{
                        title: {
                          id: "KPITitle.id",
                          hard: "MB",
                        },
                      }}
                      classStyle="title-accordion"
                    />
                  </div>
                  <div
                    style={{
                      height: "36px",
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={PdvsConquistar}
                      alt="Conquistar"
                      style={{ width: "32px", height: "32px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"mnZGFCR"}
                      reference={{ id: "mnZGFCR" }}
                      style={{ marginTop: "8px" }}
                    />
                    <img
                      src={PdvsAlavancar}
                      alt="Alavancar"
                      style={{ width: "32px", height: "32px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"UDuRQHe"}
                      reference={{ id: "UDuRQHe" }}
                      style={{ marginTop: "8px" }}
                    />
                    <img
                      src={PdvsTrabalhar}
                      alt="Trabalhar"
                      style={{ width: "32px", height: "32px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"mvtXbJj"}
                      reference={{ id: "mvtXbJj" }}
                      style={{ marginTop: "8px" }}
                    />
                    <img
                      src={Oportunidade}
                      alt="Oportunidades"
                      style={{ width: "36px", height: "36px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"THkEKp"}
                      reference={{ id: "THkEKp" }}
                      style={{ marginTop: "8px" }}
                    />
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      height: "300px",
                    }}
                  >
                    <div style={{ width: "40%", marginRight: "20PX" }}>
                      {/* TOTAL DE PDVS*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[0]} />} Total de PDVs</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"UXBKJ"}
                            reference={{ id: "UXBKJ" }}
                          />
                        </div>
                      </div>
                      {/* TICKET MEDIO PDVS PARA CLIENTE*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[1]} />} Ticket Médio PDVs para cliente</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"YPyaS"}
                            reference={{ id: "YPyaS" }}
                          />
                        </div>
                      </div>
                      {/* PDVS NOVOS*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[2]} />} PDVs Novos</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"mnZGFCR"}
                            reference={{ id: "mnZGFCR" }}
                          />
                        </div>
                      </div>
                      {/* PDVS A TRABALHAR*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[3]} />} PDVs a Trabalhar</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"mvtXbJj"}
                            reference={{ id: "mvtXbJj" }}
                          />
                        </div>
                      </div>
                      {/* OPORTUNIDADES EM REAIS*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[4]} />} Oportunidades em reais</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"THkEKp"}
                            reference={{ id: "THkEKp" }}
                          />
                        </div>
                      </div>
                      {/* INPUT DO TICKET MEDIO */}
                      <div style={{ marginTop: "20px" }}>
                        <h3>
                          Qual valor/percentual de ticket médio quer atingir?
                        </h3>
                        <div
                          style={{
                            display: "flex",
                            marginTop: "40px",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ width: "65%" }}>
                            <Slider
                              aria-label="Always visible"
                              defaultValue={vSimulPercReaisMB}
                              getAriaValueText={valuetext}
                              onChangeCommitted={handleSliderChangeCommittedMB}
                              step={10}
                              marks={marks}
                              valueLabelDisplay="on"
                            />
                          </div>
                          <div style={{ width: "30%" }}>
                            {/* 
                          lINK DE COMO TRANSFORMAR INPUT MASK DO MUI 
                          https://github.com/unicef/material-ui-currency-textfield/blob/master/src/components/CurrencyTextField/CurrencyTextField.js
                          */}
                            <div style={{ width: "100%", height: "100%" }}>
                              <NativeObject
                                className="text-accordion-medio"
                                app={app}
                                key={"gUxwzS"}
                                reference={{ id: "gUxwzS" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "60%",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          marginBottom: "20px",
                        }}
                      >
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#1E69AE1A",
                            borderRadius: "4px",
                          }}
                        >
                          <span>LB</span>
                        </div>
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#D3EAFF66",
                            borderRadius: "4px",
                          }}
                        >
                          <span>VLB</span>
                        </div>
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#EBEBEB",
                            borderRadius: "4px",
                          }}
                        >
                          <span>SC</span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                        }}
                      >
                        {/* LB INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          {" "}
                          <OutlinedInput
                            id="outlined-adornment-lb"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvLBtoMB}
                            onBlur={handleChangeMBLB}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                height: "33%",
                                alignItems: "center",
                              }}
                            >
                              <TooltipInfo
                                text={container[1].cards[0].subcards[2].tooltips[0]}
                                style={{ marginRight: "8px" }}
                              />
                              <NativeObject
                                className="text-accordion"
                                app={app}
                                key={"ZWLaEb"}
                                reference={{ id: "ZWLaEb" }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                height: "33%",
                                alignItems: "center",
                              }}
                            >
                              <TooltipInfo
                                text={container[1].cards[0].subcards[2].tooltips[1]}
                                style={{ marginRight: "8px" }}
                              />
                              <NativeObject
                                className="text-accordion"
                                app={app}
                                key={"PREdS"}
                                reference={{ id: "PREdS" }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                height: "33%",
                                alignItems: "center",
                              }}
                            >
                              <TooltipInfo
                                text={container[1].cards[0].subcards[2].tooltips[2]}
                                style={{ marginRight: "8px" }}
                              />
                              <NativeObject
                                className="text-accordion"
                                app={app}
                                key={"FMynE"}
                                reference={{ id: "FMynE" }}
                              />
                            </div>
                          </div>
                        </div>
                        {/* VLB INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          {" "}
                          <OutlinedInput
                            id="outlined-adornment-vlb"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvVLBtoMB}
                            onBlur={handleChangeMBVLB}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"LJRFbe"}
                              reference={{ id: "LJRFbe" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"ZFPBSEc"}
                              reference={{ id: "ZFPBSEc" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"ZGWPr"}
                              reference={{ id: "ZGWPr" }}
                              style={{ height: "33%" }}
                            />
                          </div>
                        </div>
                        {/* SC INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          {" "}
                          <OutlinedInput
                            id="outlined-adornment-sc"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvSCtoMB}
                            onBlur={handleChangeMBSC}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"TNL"}
                              reference={{ id: "TNL" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"snDYuK"}
                              reference={{ id: "snDYuK" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"usuSNu"}
                              reference={{ id: "usuSNu" }}
                              style={{ height: "33%" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel4"}
                onChange={handleChange("panel4")}
                elevation={0}
                sx={{
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  position: "static",
                  marginBottom: "8px",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  sx={{
                    background: "#1E69AE",
                    color: "#fff",
                    borderRadius: "8px",
                  }}
                  aria-controls="panel4bh-content"
                  id="panel4bh-header"
                >
                  <div
                    style={{
                      height: "38px",
                      width: "100px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <ComboHeader
                      reference={{
                        title: {
                          id: "KPITitle.id",
                          hard: "LB",
                        },
                      }}
                      classStyle="title-accordion"
                    />
                  </div>
                  <div
                    style={{
                      height: "36px",
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={PdvsConquistar}
                      alt="Conquistar"
                      style={{ width: "32px", height: "32px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"qJSxMY"}
                      reference={{ id: "qJSxMY" }}
                      style={{ marginTop: "8px" }}
                    />
                    <img
                      src={PdvsAlavancar}
                      alt="Alavancar"
                      style={{ width: "32px", height: "32px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"rMEhQBp"}
                      reference={{ id: "rMEhQBp" }}
                      style={{ marginTop: "8px" }}
                    />
                    <img
                      src={PdvsTrabalhar}
                      alt="Trabalhar"
                      style={{ width: "32px", height: "32px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"eSMn"}
                      reference={{ id: "eSMn" }}
                      style={{ marginTop: "8px" }}
                    />
                    <img
                      src={Oportunidade}
                      alt="Oportunidades"
                      style={{ width: "36px", height: "36px" }}
                    />
                    <NativeObject
                      className="kpi-title-accordion"
                      app={app}
                      key={"yPhKhc"}
                      reference={{ id: "yPhKhc" }}
                      style={{ marginTop: "8px" }}
                    />
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      height: "300px",
                    }}
                  >
                    <div style={{ width: "40%", marginRight: "20PX" }}>
                      {/* TOTAL DE PDVS*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[0]} />} Total de PDVs</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"e404aa46-a8fe-4ac5-b237-bddd5e48bf95"}
                            reference={{
                              id: "e404aa46-a8fe-4ac5-b237-bddd5e48bf95",
                            }}
                          />
                        </div>
                      </div>
                      {/* TICKET MEDIO PDVS PARA CLIENTE*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[1]} />} Ticket Médio PDVs para cliente</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"tzaMkLt"}
                            reference={{ id: "tzaMkLt" }}
                          />
                        </div>
                      </div>
                      {/* PDVS NOVOS*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[2]} />} PDVs Novos</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"qJSxMY"}
                            reference={{ id: "qJSxMY" }}
                          />
                        </div>
                      </div>
                      {/* PDVS A TRABALHAR*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[3]} />} PDVs a Trabalhar</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"eSMn"}
                            reference={{ id: "eSMn" }}
                          />
                        </div>
                      </div>
                      {/* OPORTUNIDADES EM REAIS*/}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "30px",
                        }}
                      >
                        <h3>{<TooltipInfo text={labelTooltips[4]} />} Oportunidades em reais</h3>
                        <div style={{ width: "50%", height: "100%" }}>
                          <NativeObject
                            className="text-accordion"
                            app={app}
                            key={"yPhKhc"}
                            reference={{ id: "yPhKhc" }}
                          />
                        </div>
                      </div>
                      {/* INPUT DO TICKET MEDIO */}
                      <div style={{ marginTop: "20px" }}>
                        <h3>
                          Qual valor/percentual de ticket médio quer atingir?
                        </h3>
                        <div
                          style={{
                            display: "flex",
                            marginTop: "40px",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ width: "65%" }}>
                            <Slider
                              aria-label="Always visible"
                              defaultValue={vSimulPercReaisLB}
                              getAriaValueText={valuetext}
                              onChangeCommitted={handleSliderChangeCommittedLB}
                              step={10}
                              marks={marks}
                              valueLabelDisplay="on"
                            />
                          </div>
                          <div style={{ width: "30%" }}>
                            {/* 
                          lINK DE COMO TRANSFORMAR INPUT MASK DO MUI 
                          https://github.com/unicef/material-ui-currency-textfield/blob/master/src/components/CurrencyTextField/CurrencyTextField.js
                          */}
                            <div style={{ width: "100%", height: "100%" }}>
                              <NativeObject
                                className="text-accordion-medio"
                                app={app}
                                key={"RxQmY"}
                                reference={{ id: "RxQmY" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "60%",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          marginBottom: "20px",
                        }}
                      >
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#D3EAFF66",
                            borderRadius: "4px",
                          }}
                        >
                          <span>VLB</span>
                        </div>
                        <div
                          style={{
                            width: "110px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#EBEBEB",
                            borderRadius: "4px",
                          }}
                        >
                          <span>SC</span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                        }}
                      >
                        {/* VLB INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          {" "}
                          <OutlinedInput
                            id="outlined-adornment-vlb"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvVLBtoLB}
                            onBlur={handleChangeLBVLB}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                height: "33%",
                                alignItems: "center",
                              }}
                            >
                              <TooltipInfo
                                text={container[1].cards[0].subcards[3].tooltips[0]}
                                style={{ marginRight: "8px" }}
                              />
                              <NativeObject
                                className="text-accordion"
                                app={app}
                                key={"cxGEuqR"}
                                reference={{ id: "cxGEuqR" }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                height: "33%",
                                alignItems: "center",
                              }}
                            >
                              <TooltipInfo
                                text={container[1].cards[0].subcards[3].tooltips[1]}
                                style={{ marginRight: "8px" }}
                              />
                              <NativeObject
                                className="text-accordion"
                                app={app}
                                key={"HJLjQY"}
                                reference={{ id: "HJLjQY" }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                height: "33%",
                                alignItems: "center",
                              }}
                            >
                              <TooltipInfo
                                text={container[1].cards[0].subcards[3].tooltips[2]}
                                style={{ marginRight: "8px" }}
                              />
                              <NativeObject
                                className="text-accordion"
                                app={app}
                                key={"PLjhu"}
                                reference={{ id: "PLjhu" }}
                              />
                            </div>
                          </div>
                        </div>
                        {/* SC INPUT % */}
                        <div
                          style={{
                            width: "110px",
                          }}
                        >
                          {" "}
                          <OutlinedInput
                            id="outlined-adornment-sc"
                            size="small"
                            type="number"
                            inputProps={{ step: 1, min: 0, max: 100 }}
                            defaultValue={vSimulPercPdvSCtoLB}
                            onBlur={handleChangeLBSC}
                            startAdornment={
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                          />
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              marginTop: "4px",
                            }}
                          >
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"FeSA"}
                              reference={{ id: "FeSA" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"NDAxnNr"}
                              reference={{ id: "NDAxnNr" }}
                              style={{ height: "33%" }}
                            />
                            <NativeObject
                              className="text-accordion"
                              app={app}
                              key={"ddUESjS"}
                              reference={{ id: "ddUESjS" }}
                              style={{ height: "33%" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </Card>
            {/* <Card
              header={{
                // hardTitle: container[1].cards[1].title.hardTitle,
                hardTitle:
                  "Você tem oportunidade de crescimento nos perfis abaixo",
                hardSubtitle: container[1].cards[1].subtitle.hard,
              }}
              style={{ width: "25%", height: "100%" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "150px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "10px",
                  }}
                >
                  <ComboHeader
                    reference={{
                      title: {
                        id: "KPITitle.id",
                        hard: "HOT HEAVY BUYERS",
                      },
                    }}
                  />
                  <h3>
                    Você pode atacar XX PDVs com 20%, para um faturamento maior.
                  </h3>
                  <ProgressBar
                    bgColor={"red"}
                    completed={40}
                    max={"100"}
                    
                  ></ProgressBar>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "150px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "10px",
                  }}
                >
                  <ComboHeader
                    reference={{
                      title: {
                        id: "KPITitle.id",
                        hard: "HEAVY BUYERS",
                      },
                    }}
                  />
                  <h3>
                    Você pode atacar XX PDVs com 20%, para um faturamento maior.
                  </h3>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "150px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "10px",
                  }}
                >
                  <ComboHeader
                    reference={{
                      title: {
                        id: "KPITitle.id",
                        hard: "MIDDLE BUYERS",
                      },
                    }}
                  />
                  <h3>
                    Você pode atacar XX PDVs com 20%, para um faturamento maior.
                  </h3>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "150px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "10px",
                  }}
                >
                  <ComboHeader
                    reference={{
                      title: {
                        id: "KPITitle.id",
                        hard: "LOW BUYERS",
                      },
                    }}
                  />
                  <h3>
                    Você pode atacar XX PDVs com 20%, para um faturamento maior.
                  </h3>
                </div>
              </div>
            </Card> */}
          </CardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

SimuladorDesktop.defaultProps = {
  app: null,
  config: {},
};

SimuladorDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SimuladorDesktop;
